export interface IMoney {
  amount: number
  currency: string
}

export function formatMoney(locale: string, money: IMoney) {
  return money.amount.toLocaleString(locale, {
    currency: money.currency,
    minimumFractionDigits: 0,
    style: 'currency',
    useGrouping: true,
  })
}
